import React from 'react';
import cm from 'classnames';

import styles from '../_sections.module.scss';

type Props = {
  expanded: boolean;
  children: React.ReactNode;
};

export const Section = ({ expanded, children }: Props) => {
  return (
    <div
      data-testid="project-table"
      className={cm(styles.Accordion__section, {
        [styles['Accordion__section--expanded']]: expanded,
      })}
    >
      {children}
    </div>
  );
};
